<template>
    <div class="bg-gray-50 rounded-xl py-3 px-4 mt-4">
        <div class="flex items-center text-sm">
            <InfoModal title="Toebehoren" :infoIcon="true" link="/api/blocks/toebehoren">
                <strong class="inline-block font-semibold">Toebehoren</strong>
            </InfoModal>

            <span class="ml-2 text-gray-600">(Optioneel)</span>
        </div>
        <div class="md:inline-flex md:gap-4 mt-4 flex flex-wrap">
            <div class="md:w-fit mb-4 md:mb-0 w-1/2 pr-4 md:pr-0" v-if="product.brand_id == 1">
                <div
                    class="flex items-center group h-full cursor-pointer bg-white hover:border-gray-400 transition-all text-gray-600 border rounded md:rounded-lg px-2 md:px-3 py-1.5 shadow space-x-3"
                    @click="addRimlock"
                >
                    <fa :icon="['fal', 'plus']" class="h-4 w-4" />
                    <!-- <vue-picture
                        :image="{
                            src: asset('img/config/oplegslot.webp'),
                            origin_src: asset('img/config/oplegslot.png'),
                        }"
                        :width="30"
                        :height="35"
                    /> -->
                    <span class="group-hover:text-gray-900 text-sm">Oplegslot</span>
                </div>
            </div>

            <div class="md:w-fit mb-4 md:mb-0 w-1/2 pr-4 md:pr-0">
                <div
                    class="flex items-center group h-full cursor-pointer bg-white hover:border-gray-400 transition-all text-gray-600 border rounded md:rounded-lg px-2 md:px-3 py-1.5 shadow space-x-3"
                    @click="addPadlock"
                >
                    <fa :icon="['fal', 'plus']" class="h-4 w-4" />
                    <!-- <vue-picture
                        :image="{
                            src: asset('img/config/hangslot.webp'),
                            origin_src: asset('img/config/hangslot.png'),
                        }"
                        :width="30"
                        :height="42"
                    /> -->
                    <span class="group-hover:text-gray-900 text-sm">Hangslot</span>
                </div>
            </div>

            <div class="md:w-fit mb-4 md:mb-0 w-1/2 pr-4 md:pr-0" v-if="product.brand_id == 1">
                <div
                    v-if="smartlocks"
                    class="flex items-center group cursor-pointer bg-white hover:border-gray-400 transition-all text-gray-600 md:w-fit w-auto border rounded md:rounded-lg px-2 md:px-3 py-1.5 shadow space-x-3"
                    @click="showModalSmartlock"
                >
                    <fa :icon="['fal', 'plus']" class="h-4 w-4" />
                    <!-- <vue-picture
                        :image="{
                            src: asset('img/config/smartlock.webp'),
                            origin_src: asset('img/config/smartlock.png'),
                        }"
                        :width="30"
                        :height="35"
                    /> -->
                    <span class="group-hover:text-gray-900 text-sm">Smart lock</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

let emit = defineEmits(['showModalSmartlock', 'addPadlock', 'addRimlock']);

const props = defineProps({
    smartlocks: Boolean,
    product: Object,
});

function showModalSmartlock() {
    emit('showModalSmartlock', false);
}

function addPadlock() {
    let gtmevent = 'add_padlock_to_set';

    dataLayer.push({ event: gtmevent });

    if (typeof hj !== 'undefined') {
        hj('event', gtmevent);
    }

    emit('addPadlock', false);
}

function addRimlock() {
    let gtmevent = 'add_rimlock_to_set';

    dataLayer.push({ event: gtmevent });

    if (typeof hj !== 'undefined') {
        hj('event', gtmevent);
    }

    emit('addRimlock', false);
}
</script>
